import React from 'react';
import ReactDOM from 'react-dom/client';
import SchedulePage from './components/SchedulePage';
import './styles.css';

// Получаем параметры из URL
const urlParams = new URLSearchParams(window.location.search);
const org = urlParams.get('org') || 'college';
const orgName = org === 'college' 
  ? 'Уральский региональный колледж' 
  : 'Южно-Уральский технологический университет';

// Применяем тему
if (org === 'college') {
  document.body.classList.add('college-theme');
} else {
  // Устанавливаем favicon для ЮУТУ
  const existingLink = document.querySelector("link[rel='shortcut icon']");
  if (existingLink) {
    existingLink.href = '/img/faviconYUTU.png';
  } else {
    const link = document.createElement('link');
    link.rel = 'shortcut icon';
    link.href = '/img/faviconYUTU.png';
    link.type = 'image/png';
    document.head.appendChild(link);
  }
}

const handleBack = () => {
  window.location.href = '/';
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SchedulePage
      organization={org}
      organizationName={orgName}
      onBack={handleBack}
    />
  </React.StrictMode>
);

